import { Sheet } from "@/interface/dataInterface";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { FC, useEffect, useState } from "react";
import { format, subYears } from "date-fns";
import { Label } from "../ui/label";
import DatePicker from "../input/DatePicker";
import { handleFormChange } from "@/utils/formChange";
import { toast } from "sonner";

interface Props {
  customOpen: boolean;
  setCustomOpen: any;
  startDate: Date;
  setStartDate: any;
  endDate?: Date;
  setEndDate?: any;
}
const DateRange: FC<Props> = ({
  customOpen,
  setCustomOpen,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  const [filterDates, setFilterDates] = useState({
    startDate, endDate
  })
  
  const handleCustomConfirm = () => {
    if (!filterDates.endDate) {
      setStartDate(filterDates.startDate)
      setEndDate(filterDates.startDate)
      setCustomOpen(false)
      return;
    }
    if (filterDates.startDate > filterDates.endDate) {
      toast("End date cannot be greater than start date.")
      return;
    }
    setStartDate(filterDates.startDate)
    setEndDate(filterDates.endDate)
    const dialogTimeout = setTimeout(() => {
      setCustomOpen(false)
    }, 500)

    return () => {
      clearTimeout(dialogTimeout)
    }
  }
  
  return (
    <Dialog open={customOpen} onOpenChange={setCustomOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Custom Date</DialogTitle>
        </DialogHeader>

        <div className="grid min-[550px]:grid-cols-2 place-items-center gap-4">
          <div className="w-full">
            <Label className="mb-2">Start Date</Label>
            <DatePicker id="startDate" value={filterDates.startDate} setValue={(e: any) => handleFormChange(e, setFilterDates)} minDate={subYears(new Date(), 1)}/>
            {/* <h3 className="text-[12px] font-semibold pl-1 pb-1">Start Date</h3>
            <input
              type="date"
              className="w-[233px] border rounded px-3 py-2 text-sm"
              value={startDate ? format(startDate, "yyyy-MM-dd") : ""}
              onChange={(e) => handleFormChange(e, setFilterDates)}
            /> */}
          </div>

          <div className="w-full">
             <Label className="mb-2">End Date</Label>
            <DatePicker id="endDate" value={filterDates.endDate} setValue={(e: any) => handleFormChange(e, setFilterDates)} minDate={filterDates.startDate}/>
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <Button variant="ghost" onClick={() => setCustomOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleCustomConfirm}
            disabled={(!filterDates.startDate || !filterDates.endDate)}
          >
            Confirm
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DateRange;
